import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showLoading)?_c('div',{staticClass:"wevo-loading-position"},[_c(VProgressCircular,{attrs:{"size":70,"width":7,"color":"white","indeterminate":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }